import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import {Location} from '@angular/common';

import { BasicValidators } from '../shared/basic-validators';
import {Funcoes} from "../funcoes";
import {Global} from "../global";
import {MercadoriasService} from "../mercadorias/mercadorias.service";
import {MercadoriasVariedadesModel} from "./mercadorias-variedades.model";
import {MercadoriasVariedadesService} from "./mercadorias-variedades.service";


@Component({
  selector: 'app-mercadorias-variedades-form',
  templateUrl: './mercadorias-variedades-form.component.html'
})
export class MercadoriasVariedadesFormComponent implements OnInit {

  form: FormGroup;
  title: string;
  variedade: MercadoriasVariedadesModel = new MercadoriasVariedadesModel();
  pageIsUpd: boolean = false;
  pageIsAdd: boolean = false;
  enviando = false;
  listMercadorias = [];

  constructor(
    formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private mercadoriasVariedadesService: MercadoriasVariedadesService,
    private mercadoriasService: MercadoriasService,
    private _location: Location,
    public func: Funcoes,
    public global: Global
  ) {
    this.form = formBuilder.group({
      id: [],
      id_mercadoria: ['', [
        Validators.required
      ]],
      nome: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(45)
      ]]
    });
  }

  ngOnInit() {

    const urlPath = this.router.url.split('?')[0];
    const lastSegment = urlPath.split(/\//).pop();

    // verifica se é uma página de edição
    if(lastSegment == 'upd'){
      this.pageIsUpd = true;
    }

    // verifica se é uma página para adicionar
    if(lastSegment == 'add'){
      this.pageIsAdd = true;
    }

    this.mercadoriasService.get()
      .subscribe(
        json => {
          this.listMercadorias = json.Payload;

          if(this.global.debug == true){
            console.log(json.Payload);
          }
        },
        error => {
          this.func.showErro(error.json());
        });

    this.route.params.subscribe(params => {
      let id = params['id_variedade'];

      if(!this.pageIsUpd){
        this.title = this.func.traduzir('front.editarVariedade');
      }else{
        this.title = id ? this.func.traduzir('front.visualizarVariedade') : this.func.traduzir('front.cadastrarNovaVariedade');
      }

      if (!id) {
        if (this.route.snapshot.queryParams["mercadoria"]) {
          this.variedade.id_mercadoria = this.route.snapshot.queryParams["mercadoria"];
        }
        return;
      }

      this.mercadoriasVariedadesService.getById(id)
        .subscribe(
          json => {
            if(this.pageIsUpd) {
              this.title = this.func.traduzir('front.editarVariedade')+': '+json.Payload[0].nome;
            }else{
              this.title = this.func.traduzir('front.visualizarVariedade') + ': ' + json.Payload[0].nome;
            }
            this.variedade = json.Payload[0];

            if(this.global.debug == true){
              console.log(json.Payload[0]);
            }
          },
          error => {
            this.func.showErro(error.json());
          });
    });
  }

  voltar() {
    const idMercadoria = this.route.snapshot.queryParams["mercadoria"] || this.variedade.id_mercadoria;
    if (idMercadoria) {
      this.router.navigate(['/painel', 'mercadorias', idMercadoria, 'upd'], { queryParams: { abavariedades: '1' } });
    } else {
      this._location.back();
    }
  }

  save() {
    this.enviando = true;
    let result,

    values = this.form.value;

    if (values.id) {
      result = this.mercadoriasVariedadesService.editar(values, values.id);
    } else {
      result = this.mercadoriasVariedadesService.adicionar(values);
    }

    const idMercadoria = this.route.snapshot.queryParams["mercadoria"] || values.id_mercadoria || this.variedade.id_mercadoria;

    result.subscribe(data => {
        if (idMercadoria) {
          this.router.navigate(['/painel', 'mercadorias', idMercadoria, 'upd'], { queryParams: { abavariedades: '1' } });
        } else {
          this.router.navigate(['/painel', 'mercadorias', 'variedades']);
        }
      },
      error => {
        this.enviando = false;
        this.func.showErro(error.json());
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/mercadorias-variedades/mercadorias-variedades-form.component.ts